module.exports = __webpack_public_path__ + "img/expand.f1fd29d3.svg";